import { render } from "./VehicleModerationHelperDialog.vue?vue&type=template&id=b3111dde&ts=true"
import script from "./VehicleModerationHelperDialog.vue?vue&type=script&lang=ts"
export * from "./VehicleModerationHelperDialog.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehicleModerationHelperDialog.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__